import React, {useEffect} from 'react';

export default function ErrorPage() {
  useEffect(() => {
    document.body.classList.add('app-error');
    return () => {
      document.body.classList.remove('app-error');
    };
  }, []);

  return (
    <div className="page-error">
      <div className="page-error-wrapper">
        <h1>
          <i className="icon-b icon-b-exclamation-circle" />
          Uh oh!
        </h1>
        <div className="message">
          Something went wrong, please click
          {' '}
          <a
            href={window.location.href}
            onClick={() => {
              window.location.reload();
            }}
          >
            refresh
          </a>
          {' '}
          to resolve. If you continue to experience issues, please contact
          {' '}
          <a href="mailto:support@gridics.com">support@gridics.com</a>
        </div>
      </div>
    </div>
  );
}
